import { createStore } from '@stencil/store';

const initialState = {
  questions: [],
  questionsDashboard: [], // section: vehicle condition, item: dashboard, subsectionCode: interior, label: stains
  questionsFrontSeats: [], // section: vehicle condition, item: front seats, subsectionCode: interior, label: stains
  questionsRearSeats: [], // section: vehicle condition, item: rear seats, subsectionCode: interior, label: stains
  questionsCargoBed: [], // section: vehicle condition, item: cargo bed, subsectionCode: interior, label: stains
  questionsThirdRowSeats: [], // section: vehicle condition, item: 3rd row, subsectionCode: interior, label: stains // current defect in production hides this. need double check
  questionsHeadliner: [], // section: vehicle condition, item: headliner, subsectionCode: interior, label: stains
  questionsCarpet: [], // section: vehicle condition, item: carpet, subsectionCode: interior, label: stains
  questionsMoldingTrim: [], // section: vehicle condition, item: molding/trim, subsectionCode: interior, label: pieces have small dings
  questionsOdors: [], // imported questions: history:"qp/65"
  questionsDashboardLights: [], // section: vehicle condition, item: ABS, subsectionCode: WarningLights, label: ABS
  conditionPageSche: 0,
  conditionPageDbl: 0,
};

const { state, on, onChange, reset } = createStore(initialState);

export { on, state, onChange, reset };
export default state;
